var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 34,
    viewBox: "0 0 52 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1686 33H10.2964C-2.87236 33 -1.8972 11.4203 12.2473 13.8733C13.2227 -2.80031 39.0723 -4.27233 39.0723 15.3446C54.1918 11.912 54.6796 33 41.9987 33H37.5796M26.3618 33V12.8929M26.3618 12.8929L31.2391 17.7972M26.3618 12.8929L21.4846 17.7972",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.7b96465f29442455af9b155ac93cfccc.svg";
export { ForwardRef as ReactComponent };